import { useEffect, useRef, VFC, RefObject, ComponentType } from 'react';
import { connect, FormikProps } from 'formik';

type ScrollErrorToViewProps = {
  formik: FormikProps<any>;
  fieldRefs: Record<string, RefObject<HTMLDivElement>>;
};

type ConnectedScrollErrorToViewProps = Omit<ScrollErrorToViewProps, 'formik'>;

export const ScrollErrorToView: VFC<ScrollErrorToViewProps> = ({ formik, fieldRefs }) => {
  const { submitCount, isValid, errors } = formik;
  const prevSubmitCountRef = useRef(submitCount);

  useEffect(() => {
    const shouldScrollIntoError = submitCount > prevSubmitCountRef.current && !isValid;
    if (shouldScrollIntoError) {
      const invalidFieldNodes = Object.keys(errors)
        .map((key) => fieldRefs[key]?.current)
        .filter((node): node is HTMLDivElement => Boolean(node));

      const topmostInvalidField = invalidFieldNodes.reduce<HTMLDivElement | undefined>(
        (topmost, node) => {
          if (!topmost) return node;
          return topmost.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_PRECEDING
            ? node
            : topmost;
        },
        undefined,
      );

      if (topmostInvalidField) {
        topmostInvalidField.scrollIntoView();
      }
    }

    prevSubmitCountRef.current = submitCount;
  }, [submitCount, errors, isValid, fieldRefs]);

  return null;
};

const Connected: ComponentType<ConnectedScrollErrorToViewProps> =
  connect<ConnectedScrollErrorToViewProps>(ScrollErrorToView);

export default Connected;
